import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as Styles from './SplitPanel.module.scss';
export function SplitPanel(props) {
    const panelRef = React.useRef(null);
    const [sidePanelWidth, setSidePanelWidth] = React.useState(undefined);
    const dragging = React.useRef(false);
    const startX = React.useRef(0);
    const startWidth = React.useRef(0);
    // Mouse events
    const onMouseDown = (e) => {
        dragging.current = true;
        startX.current = e.clientX;
        startWidth.current =
            panelRef.current?.firstElementChild instanceof HTMLElement
                ? panelRef.current.firstElementChild.offsetWidth
                : 0;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        e.preventDefault();
    };
    const onMouseMove = (e) => {
        if (!dragging.current)
            return;
        const dx = e.clientX - startX.current;
        setSidePanelWidth(Math.max(50, startWidth.current + dx));
    };
    const onMouseUp = () => {
        dragging.current = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    };
    // Touch events
    const onTouchStart = (e) => {
        dragging.current = true;
        startX.current = e.touches[0].clientX;
        startWidth.current =
            panelRef.current?.firstElementChild instanceof HTMLElement
                ? panelRef.current.firstElementChild.offsetWidth
                : 0;
        document.addEventListener('touchmove', onTouchMove);
        document.addEventListener('touchend', onTouchEnd);
        e.preventDefault();
    };
    const onTouchMove = (e) => {
        if (!dragging.current)
            return;
        const dx = e.touches[0].clientX - startX.current;
        setSidePanelWidth(Math.max(50, startWidth.current + dx));
    };
    const onTouchEnd = () => {
        dragging.current = false;
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
    };
    // Clean up listeners on unmount
    React.useEffect(() => {
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('touchmove', onTouchMove);
            document.removeEventListener('touchend', onTouchEnd);
        };
    }, []);
    // Set CSS variable for sidePanelWidth
    React.useEffect(() => {
        if (panelRef.current && sidePanelWidth) {
            panelRef.current.style.setProperty('--split-panel-side-width', `${sidePanelWidth}px`);
        }
        else if (panelRef.current) {
            panelRef.current.style.removeProperty('--split-panel-side-width');
        }
    }, [sidePanelWidth]);
    return (_jsxs("div", { ref: panelRef, className: Styles.splitPanelRoot, children: [_jsx("div", { className: Styles.sidePanel, children: props.sidePanel }), _jsx("div", { className: Styles.resizer, onMouseDown: onMouseDown, onTouchStart: onTouchStart, role: "separator", "aria-orientation": "vertical", tabIndex: 0, children: "======" }), _jsx("div", { children: props.children })] }));
}
